import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import RecentPayments from "../components/RecentPayments";

export default function Dashboard() {
	return (
		<div className="min-h-screen w-full bg-gradient-to-br from-pink-50 via-orange-50 to-yellow-50">
			{/* Main Content */}
			<main className="p-4 sm:p-8">
				<div className="max-w-6xl mx-auto">
					{/* Header */}
					<div className="flex flex-col md:flex-row justify-between items-center mb-8">
						<h1 className="text-2xl font-semibold text-gray-900">Payment Dashboard</h1>
						<Link
							to="/payments/new"
							className="group bg-gradient-to-r from-orange-400 to-pink-400 hover:from-orange-500 hover:to-pink-500 text-white font-semibold px-4 py-2 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 mt-3 md:mt-0 w-auto"
						>
							<Plus className="w-5 h-5" />
							New Payment
						</Link>
					</div>

					{/* Recent Payments */}
					<RecentPayments />
				</div>
			</main>
		</div>
	);
}
